import PropTypes from "prop-types";
import { FormLabel } from "@mui/material";

import TextInput from "../../../ui/TextInput";
import { INTERSECTION_NUMBERS } from "../../../constants/storageConstants";

export default function ObservedCrashesFields({
  defaultValues,
  errors,
  formData,
  intersectionKey,
  register,
}) {
  const namePrefix = intersectionKey ? `${intersectionKey}.` : "";
  return (
    <>
      <FormLabel>Intersection Site Crashes Observed</FormLabel>
      <div style={{ display: "flex", marginTop: "15px" }}>
        <TextInput
          defaultValue={defaultValues.observedFatalInjuryCrashes}
          errors={errors}
          isRequired
          label="Fatal and Injury Crashes"
          min={0}
          name={`${namePrefix}observedFatalInjuryCrashes`}
          register={register}
          step="1"
          sx={{ marginRight: "20px" }}
          type="number"
        />
        <TextInput
          defaultValue={defaultValues.observedTotalCrashes}
          errors={errors}
          isRequired
          label="Total Crashes"
          min={formData.observedFatalInjuryCrashes}
          name={`${namePrefix}observedTotalCrashes`}
          register={register}
          step="1"
          type="number"
        />
      </div>
      <div style={{ display: "flex", marginTop: "15px" }}>
        <TextInput
          defaultValue={defaultValues.yearsOfObservedCrashData ?? 5}
          errors={errors}
          isRequired
          label="Number of Years of Crash Data"
          min={0}
          name={`${namePrefix}yearsOfObservedCrashData`}
          register={register}
          step="1"
          type="number"
        />
      </div>
    </>
  );
}

ObservedCrashesFields.propTypes = {
  defaultValues: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  intersectionKey: PropTypes.oneOf(Object.values(INTERSECTION_NUMBERS)),
  register: PropTypes.func.isRequired,
};
